<div class="col-sm-12 no-padding">

  <div class="row filter-form">
    <div class="col-md-6 col-sm-12 no-padding">
      <h1 class="no-margin">{{ 'COMPANY.MANAGER.COLABS.SECTION_TITLE' | translate }} <small>{{rowsCount}} cadastrados</small></h1>
    </div>

    <div class="clearfix"></div>

    <div class="col-md-12 col-sm-12 no-padding">
      <!-- / Filter Form -->
      <div class="row filter-form-inputs advanced-search">

        <!-- Advanced search -->
        <div class="col-md-4 col-sm-12">
          <input type="text" [(ngModel)]="advancedFilter.name" (keyup.enter)="onFilterRows(advancedFilter)"  placeholder="{{ 'COMPANY.MANAGER.COLABS.FILTER_FORM.PLACEHOLDERS.NAME' | translate }}" />
        </div>
        <div class="col-md-4 col-sm-12">
          <input type="text" [(ngModel)]="advancedFilter.email" (keyup.enter)="onFilterRows(advancedFilter)" placeholder="{{ 'COMPANY.MANAGER.COLABS.FILTER_FORM.PLACEHOLDERS.EMAIL' | translate }}" />
        </div>
        <div class="col-md-2 col-sm-12">
          <input type="text" [(ngModel)]="advancedFilter.cpf" (keyup.enter)="onFilterRows(advancedFilter)" placeholder="{{ 'COMPANY.MANAGER.COLABS.FILTER_FORM.PLACEHOLDERS.CPF' | translate }}" />
        </div>
        <div class="col-md-2 col-sm-12">
          <input type="text" [(ngModel)]="advancedFilter.employeeRegistrationNumber" (keyup.enter)="onFilterRows(advancedFilter)" placeholder="{{ 'COMPANY.MANAGER.COLABS.FILTER_FORM.PLACEHOLDERS.EMPLOYEE_REGISTRATION_NUMBER' | translate }}" />
        </div>

        <div class="clearfix"></div>

        <div class="col-md-4 col-sm-12 padding-top" *ngIf="typeBusiness === 'company' && optionsUnit?.length > 0">
          <ss-multiselect-dropdown [options]="optionsUnit" [texts]="selectUnitTexts" [settings]="settingsSelectUnit" (ngModelChange)="filterRowsByUnit($event)" [(ngModel)]="optionsModelUnit"></ss-multiselect-dropdown>
        </div>
        <div class="col-md-4 col-sm-12 padding-top">
          <ss-multiselect-dropdown [options]="optionsStatus" [texts]="selectStatusTexts" [settings]="settingsSelectStatus" (ngModelChange)="filterRowsByStatus($event)" [(ngModel)]="optionsModelStatus"></ss-multiselect-dropdown>
        </div>
        <div class="col-md-4 col-sm-12 padding-top">
          <ss-multiselect-dropdown [options]="optionsProfile" [texts]="selectProfileTexts" [settings]="settingsSelectProfile" (ngModelChange)="filterRowsByProfile($event)" [(ngModel)]="optionsModelProfile"></ss-multiselect-dropdown>
        </div>

        <div class="search-actions">
          <button class="search-colabs clear-filters" (click)="onFilterRows($event)">Limpar</button>
          <button class="search-colabs" (click)="onFilterRows(advancedFilter)">Buscar</button>
        </div>

      </div>
      <!-- / Filter Form -->
    </div>

    <div class="clearfix"></div>

    <div class="col-md-12 col-sm-12 no-padding">
      <hr />
    </div>

    <div class="clearfix"></div>

  </div>
</div>


